import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { connexion } from '../services/api';
import API from '../services/api';

const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=900&q=80';

const Connexion = () => {
  const [form, setForm] = useState({ identifiant: '', mot_de_passe: '' });
  const [erreur, setErreur] = useState('');
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(FALLBACK_IMAGE);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    API.get('/hero/image/login_image')
      .then(res => { if (res.data?.url) setImageUrl(res.data.url); })
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErreur('');
    try {
      const res = await connexion(form);
      login(res.data.token, res.data.user);
      navigate('/profil');
    } catch (err) {
      setErreur(err.response?.data?.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" style={{ background: '#0A0A0A' }}>

      {/* Gauche — image */}
      <div className="hidden md:flex md:w-1/2 relative overflow-hidden">
        <img
          src={imageUrl}
          alt="voiture"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0" style={{
          background: 'linear-gradient(to right, rgba(0,0,0,0.3), rgba(10,10,10,0.8))'
        }} />
        <div className="absolute inset-0 flex flex-col justify-center px-12">
          <h2 className="text-white text-3xl font-black mb-4">
            La marketplace automobile <span style={{ color: '#F5A623' }}>premium</span>
          </h2>
          <p className="text-gray-300 text-lg">
            Des milliers de véhicules neufs et d'occasion vous attendent.
          </p>
        </div>
      </div>

      {/* Droite — formulaire */}
      <div className="w-full md:w-1/2 flex items-center justify-center px-8 py-12">
        <div className="w-full max-w-md">

          {/* Logo centré */}
          <div className="text-center mb-6">
            <Link to="/" className="inline-block">
              <img src="/logo.jpg" alt="JJ Cars" className="h-12 w-auto object-contain mx-auto" />
            </Link>
          </div>

          <h1 className="text-white text-2xl font-black mb-1">Connexion</h1>
          <p className="text-gray-500 mb-5 text-sm">Accédez à votre compte JJ Cars</p>

          {erreur && (
            <div className="bg-red-900 bg-opacity-30 border border-red-500 text-red-400 p-2.5 rounded-xl mb-3 text-xs">
              {erreur}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-3">
            <div>
              <label className="block text-xs font-semibold text-gray-400 mb-1">
                Email ou téléphone
              </label>
              <input
                type="text"
                required
                value={form.identifiant}
                onChange={(e) => setForm({ ...form, identifiant: e.target.value })}
                style={{ background: '#1a1a1a', border: '1px solid #333', color: 'white' }}
                className="w-full px-3 py-2 rounded-xl text-sm focus:outline-none focus:border-yellow-400 transition"
                placeholder="votre@email.com ou 24100000000"
              />
            </div>

            <div>
              <div className="flex items-center justify-between mb-1">
                <label className="block text-xs font-semibold text-gray-400">
                  Mot de passe
                </label>
                <Link
                  to="/mot-de-passe-oublie"
                  style={{ color: '#F5A623' }}
                  className="text-xs font-semibold hover:opacity-80 transition"
                >
                  Mot de passe oublié ?
                </Link>
              </div>
              <input
                type="password"
                required
                value={form.mot_de_passe}
                onChange={(e) => setForm({ ...form, mot_de_passe: e.target.value })}
                style={{ background: '#1a1a1a', border: '1px solid #333', color: 'white' }}
                className="w-full px-3 py-2 rounded-xl text-sm focus:outline-none focus:border-yellow-400 transition"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{ background: '#F5A623' }}
              className="w-full text-black py-2 rounded-xl font-black text-sm hover:opacity-90 transition disabled:opacity-50"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>


          <p className="text-center text-gray-500 mt-5 text-sm">
            Pas encore de compte ?{' '}
            <Link to="/inscription" style={{ color: '#F5A623' }} className="font-bold hover:opacity-80">
              S'inscrire gratuitement
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Connexion;
